export const GET_ALL_SUBSCRIBE = 'GET_ALL_SUBSCRIBE'
export const GET_BLOCK_LIST = 'GET_BLOCK_LIST'
export const GET_CONTRACT_LIST = 'GET_CONTRACT_LIST'
export const GET_TXN_LIST = 'GET_TXN_LIST'
